import { render, staticRenderFns } from "./formulario_campo_text.vue?vue&type=template&id=3883e00a&scoped=true"
import script from "./formulario_campo_text.vue?vue&type=script&lang=js"
export * from "./formulario_campo_text.vue?vue&type=script&lang=js"
import style0 from "./formulario_campo_text.vue?vue&type=style&index=0&id=3883e00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883e00a",
  null
  
)

export default component.exports